(function () {
  'use strict';

  function initHowItWorks(root) {
    if (root.dataset.howItWorksReady === 'true') return;

    var tabs = Array.from(root.querySelectorAll('[data-how-it-works-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-how-it-works-panel]'));

    if (!tabs.length || !panels.length) {
      root.dataset.howItWorksReady = 'true';
      return;
    }

    function activateTab(value) {
      tabs.forEach(function (tab) {
        var isSelected = tab.getAttribute('data-how-it-works-tab') === value;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        tab.classList.toggle('how-it-works__tab--active', isSelected);
      });

      panels.forEach(function (panel) {
        var isSelected = panel.getAttribute('data-how-it-works-panel') === value;
        panel.hidden = !isSelected;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab.getAttribute('data-how-it-works-tab'));
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;

        if (event.key === 'ArrowRight') {
          nextIndex = (index + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        activateTab(tabs[nextIndex].getAttribute('data-how-it-works-tab'));
        tabs[nextIndex].focus();
      });
    });

    root.dataset.howItWorksReady = 'true';
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-how-it-works]').forEach(initHowItWorks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
